export const sliderItems = [
  {
    id: 1,
    img: "https://i.ibb.co/D40LVZn/tote.png",
    title: "MARC JACOBS",
    desc: "Marc Jacobs Tote Bags for Summer",
    bg: "dbdad6",
    url: "/product/64cd4843d8c331dc06d94c28",
  },
  {
    id: 2,
    img: "https://i.ibb.co/Xz9w26t/nike.png",
    title: "SUMMER",
    desc: "Show Off Your Nike Kicks In Summer Time",
    bg: "f5fafd",
    url: "/products/nike",
  },

  {
    id: 3,
    img: "https://i.ibb.co/VjB715J/supreme.png",
    title: "Supreme",
    desc: "Supreme SS23 Release",
    bg: "f5f5f5",
    url: "/products/supreme",
  },
];
export const brands = [
  {
    id: 1,
    img: "https://images.ctfassets.net/gl3ev2s7u7gx/3Cc2gyRwCUrdYqYg0IVEWk/f8e2eb48047ccf6fc940200cd34ec901/Nike_Air_Max_Day-2.jpeg?w=2000",
    title: "Nike",
    brand: "nike",
  },
  {
    id: 2,
    img: "https://assets.adidas.com/images/w_600,f_auto,q_auto/5dd810c0287244c1ba4eaf310077018b_9366/Samba_Juventus_Shoes_Black_HQ7034_HM1.jpg",
    title: "Adidas",
    brand: "adidas",
  },
  {
    id: 3,
    img: "https://media.newyorker.com/photos/5930549810ddbb45aa2252a9/master/w_2000,h_1333,c_limit/Backman-Supreme-Copies.jpg",
    title: "Supreme",
    brand: "supreme",
  },
  {
    id: 4,
    title: "Fragment",
    img: "https://cdn.shopify.com/s/files/1/0260/3241/files/DNEIMBY-1.jpg?10434272571974596006",
    brand: "fragment",
  },
  {
    id: 5,
    img: "https://app.dropinblog.com/uploaded/blogs/34240971/files/Air-Jordan-1-Lost-and-Found-DZ5485-612-Release-Date-On-Feet-2.jpg",
    title: "Jordan",
    brand: "jordan",
  },
  {
    id: 6,
    img: "https://hips.hearstapps.com/hmg-prod/images/gettyimages-631497628-1658852446.jpg",
    title: "Yeezy",
    brand: "yeezy",
  },
];
